import { render, staticRenderFns } from "./whatsapp-template-msg.vue?vue&type=template&id=3a196d6e"
import script from "./whatsapp-template-msg.vue?vue&type=script&lang=js"
export * from "./whatsapp-template-msg.vue?vue&type=script&lang=js"
import style0 from "./whatsapp-template-msg.vue?vue&type=style&index=0&id=3a196d6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports